<template>
  <div
    class="wf-button"
    :class="{
      ['wf-type-' + type]: true,
      'wf-is-plain': plain,
      'wf-is-card': card,
      'wf-is-text': text,
      'wf-is-circle': circle,
      'wf-is-disabled': disabled,
      ['wf-is-' + size]: true,
      'wf-button-has': $slots.default
    }"
    @click="check"
    :style="{ display: auto ? 'block' : 'inline-block' }"
  >
    <div class="wf-button-content" :style="{ visibility: loading ? 'hidden' : 'visible' }">
      <i class="text-icon" v-if="icon" :class="{[icon]: true, 'text-icon-no': !$slots.default}"></i>
      <slot></slot>
    </div>
    <div class="loading-box-button">
      <i v-if="loading" class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "WfButton",
  props: {
    icon: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "primary",
    },
    card: Boolean,
    plain: Boolean,
    text: Boolean,
    circle: Boolean,
    loading: Boolean,
    disabled: Boolean,
    auto: Boolean,
    size: String,
  },
  data() {
    return {};
  },
  methods: {
    check() {
      if (!this.disabled && !this.loading) {
        this.$emit("click");
      }
    },
  },
};
</script>

<style lang="scss" scope>
@import "@/assets/scss/mixin.scss";
.wf-button {
  box-sizing: border-box;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  display: inline-block;
  border-radius: 4px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  background: #2682FF;
  color: #fff;
  font-size: 14px;
  position: relative;
  border: 1px solid transparent;
  box-sizing: border-box;
  &.wf-is-large {
    height: 40px;
    line-height: 38px !important;
  }
  .loading-box-button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .wf-button-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-icon {
    color: #fff;
    font-size: 14px;
    margin-right: 8px;
    &:hover {
      color: #fff;
    }
  }
  .text-icon-no {
    margin: 0;
  }
  &:hover {
    background: #2573DE;
  }
  &:active {
    background: #2560B1;
  }
}
.wf-button-has {
  padding: 0 16px;
}
.wf-type-danger {
  color: #fff;
  background: #FF3939;
  &:hover {
    background: #D32B2B;
  }
  &:active {
    background: #B22525;
  }
}

.wf-is-text {
  color: rgba(32, 32, 32, 0.6) !important;
  background: inherit;
  i {
    color: rgba(32, 32, 32, 0.6) !important;
  }
  &:hover {
    background: rgba(32, 32, 32, 0.04) !important;
    i {
      color: #0d70e8 !important;
    }
    color: #0d70e8 !important;
    span {
      color: #0d70e8 !important;
    }
  }
  &:active {
    background: rgba(32, 32, 32, 0.08) !important;
  }
}

.wf-is-circle {
  height: 24px;
  line-height: 24px;
  padding: 0 3px;
}
.wf-type-primary.wf-is-disabled {
  cursor: not-allowed;
  background: rgba(32,32,32,0.24) !important;
  color: #fff !important;
  border-color: transparent !important;
  line-height: 30px;
  &:hover {
    background: rgba(32,32,32,0.24) !important;
    color: #fff !important;
    border-color: transparent !important;
  }
  &:active {
    background: rgba(32,32,32,0.24) !important;
    color: #fff !important;
    border-color: transparent !important;
  }
}
.wf-type-primary.wf-is-plain {
  color: #2682FF !important;
  background: #fff !important;
  border: 1px solid rgba(38, 130, 255, 0.40) !important;
  i {
    color: #2682FF !important;
  }
  &:hover {
    color: #2682FF !important;
    background: #E8F2FF !important;
    i {
      color: #2682FF !important;
    }
  }
  &:active {
    color: #2682FF !important;
    background: #D8E8FF !important;
    i {
      color: #2682FF !important;
    }
  }
}
.wf-type-danger.wf-is-plain {
  color: #ff3939 !important;
  background: #fff !important;
  border: 1px solid rgba(255, 57, 57, 0.6) !important;
  i {
    color: #ff3939 !important;
  }
  &:hover {
    color: #ff3939 !important;
    background: #fff0f0 !important;
    i {
      color: #ff3939 !important;
    }
  }
  &:active {
    color: #da2222 !important;
    background: #ffd8d8 !important;
    i {
      color: #da2222 !important;
    }
  }
}
.wf-is-plain {
  border: 1px solid rgba(32, 32, 32, 0.16) !important;
  background: #fff !important;
  color: initial;
  i {
    color: initial !important;
  }
  &:hover {
    background: #f7f8f9 !important;
    i {
      color: initial !important;
    }
    color: initial !important;
  }
  &:active {
    background: #eaebec !important;
    color: #0d1f3c;
  }
}
.wf-is-plain.wf-is-disabled {
  cursor: not-allowed;
  background: rgba(32,32,32,0.24) !important;
  color: #fff !important;
  border: none !important;
  line-height: 32px;
  &:hover {
    background: rgba(32,32,32,0.24) !important;
    color: #fff !important;
    border: none !important;
  }
  &:active {
    background: rgba(32,32,32,0.24) !important;
    color: #fff !important;
    border: none !important;
  }
  i {
    color: #fff !important;
  }
}

.wf-type-danger.wf-is-card {
  color: #ff3939 !important;
  background: #fff !important;
  &:hover {
    color: #ff3939 !important;
    background: #fff0f0 !important;
  }
  &:active {
    color: #da2222 !important;
    background: #ffd8d8 !important;
  }
}
.wf-is-card {
  background: #fff !important;
  color: rgba(89, 89, 89, 1);
  box-shadow: 0px 2px 4px 0px rgba(32, 32, 32, 0.08);
  i {
    color: rgba(89, 89, 89, 1) !important;
  }
  &:hover {
    box-shadow: 0px 6px 16px 0px rgba(58, 73, 96, 0.27) !important;
    i {
      color: rgba(89, 89, 89, 1) !important;
    }
    color: rgba(89, 89, 89, 1) !important;
  }
  &:active {
    box-shadow: 0px 6px 16px 0px rgba(58, 73, 96, 0.27) !important;
    color: #0d1f3c;
  }
}
.wf-is-card.wf-is-disabled {
  cursor: not-allowed;
  opacity: 0.4 !important;
  background: #fff !important;
  color: rgba(32, 32, 32, 0.6);
  i {
    color: rgba(32, 32, 32, 0.6) !important;
  }
  &:hover {
    border: 1px solid rgba(32, 32, 32, 0.16) !important;
    background: #fff !important;
    color: rgba(32, 32, 32, 0.6);
    opacity: 0.4 !important;
  }
  &:active {
    border: 1px solid rgba(32, 32, 32, 0.16) !important;
    background: #fff !important;
    color: rgba(32, 32, 32, 0.6);
    opacity: 0.4 !important;
  }
}

.wf-type-danger.wf-is-disabled {
  cursor: not-allowed;
  opacity: 0.4 !important;
  color: #ff3939 !important;
  background: #fff !important;
  border-color: rgba(255, 57, 57, 0.16) !important;
  &:hover {
    color: #ff3939 !important;
    background: #fff !important;
    opacity: 0.4 !important;
  }
  &:active {
    color: #ff3939 !important;
    background: #fff !important;
    opacity: 0.4 !important;
  }
}
.wf-is-mini {
  font-size: 12px;
  padding: 0 4px;
  line-height: 20px;
  height: 20px;
}
</style>
